import React from 'react'
import { observer } from 'mobx-react'
import { Tab, Tabs } from 'react-bootstrap'
import { LegalAddressAddNewForm } from './LegalAddressAddNewForm'
import { SavedLegalAddressList } from './SavedLegalAddressList'
import { i18nTranslate } from 'src/utils'
import './styles.scss'

@observer
class LegalAddressTabForms extends React.Component {
  constructor(props) {
    super(props)
  }

  getDefaultActiveTabKey = () => {
    const { savedAddressList = [] } = this.props
    const defaultTab =
      savedAddressList?.length > 0 ? 'savedAddress' : 'newAddress'
    return defaultTab
  }

  renderAddNewLegalAddressForm = () => {
    return <LegalAddressAddNewForm {...this.props} />
  }

  renderSavedAddressList = () => {
    return <SavedLegalAddressList {...this.props} />
  }

  renderLegalAddressTabs = () => {
    const { savedAddressList = [] } = this.props
    const addNewAddressTitle = i18nTranslate(
      'legalAddress.addNewAddressTitle',
      'Add New Address'
    )
    const savedAddressTitle = i18nTranslate(
      'legalAddress.savedAddressTitle',
      'Saved Address'
    )
    const defaultActiveTabKey = this.getDefaultActiveTabKey()
    const isToShowSavedAddressTab = savedAddressList?.length > 0

    return (
      <div className="legal-address-tabs-container">
        {isToShowSavedAddressTab ? (
          <Tabs
            defaultActiveKey={defaultActiveTabKey}
            id="legal-address-tabs"
            className="legal-address-tabs-wrapper"
            data-testid="qa-legal-address-tabs-wrapper">
            <Tab
              className="saved-legal-address-tab-wrapper my-3"
              eventKey="savedAddress"
              title={savedAddressTitle}
              data-testid="qa-legal-saved-address-tab">
              {this.renderSavedAddressList()}
            </Tab>
            <Tab
              className="add-legal-address-tab-wrapper"
              eventKey="newAddress"
              title={addNewAddressTitle}
              data-testid="qa-legal-add-address-tab">
              {this.renderAddNewLegalAddressForm()}
            </Tab>
          </Tabs>
        ) : (
          <Tabs
            defaultActiveKey="newAddress"
            id="legal-address-tabs"
            className="legal-address-tabs-wrapper"
            data-testid="qa-legal-address-tabs-wrapper">
            <Tab
              className="add-legal-address-tab-wrapper"
              eventKey="newAddress"
              title={addNewAddressTitle}
              data-testid="qa-legal-add-address-tab">
              {this.renderAddNewLegalAddressForm()}
            </Tab>
          </Tabs>
        )}
      </div>
    )
  }

  render() {
    return <div>{this.renderLegalAddressTabs()}</div>
  }
}

export default LegalAddressTabForms
export { LegalAddressTabForms }
